import React from "react";
import { View, ActivityIndicator, ViewStyle, StyleProp } from "react-native";
import { spinnerStyles as styles } from "./styles";

interface SpinnerProps {
  size?: "large" | "small";
  theme?: "dark" | "light";
  styles?: {
    container?: StyleProp<ViewStyle>;
  };
}

const Spinner: React.FC<SpinnerProps> = ({
  styles: customStyles,
  size = "small",
  theme = "light",
}) => {
  const color = theme === "light" ? "#fff" : "rgba(0,0,0,0.25)";

  return (
    <View style={customStyles?.container} testID="spinner">
      <ActivityIndicator color={color} size={size} style={styles.spinner} />
    </View>
  );
};

export default Spinner;
